import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getWeeklyReading, fetchPassages } from "../utils/weeklyReading";
import PortionCommentary from "./PortionCommentary";
import PortionOthersCommentary from "./PortionOthersCommentary";

function HaftarahPortion({ loggedIn }) {
  const [loading, setLoading] = useState(true);
  const [portionName, setPortionName] = useState("");
  const [portionHebrew, setPortionHebrew] = useState("");
  const [haftarahRef, setHaftarahRef] = useState("");
  const [haftarahText, setHaftarahText] = useState("");
  const [error, setError] = useState("");
  const [isFestival, setIsFestival] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        const reading = await getWeeklyReading();
        if (!reading) {
          setError("Could not detect current Torah portion.");
          return;
        }

        setPortionName(reading.name);
        setPortionHebrew(reading.hebrew);
        setIsFestival(reading.isFestival);

        if (reading.haftarahIds.length === 0) {
          setError(`No Haftarah data found for portion: ${reading.name}`);
          return;
        }

        setHaftarahRef(reading.haftarahRef);
        setHaftarahText(await fetchPassages(reading.haftarahIds));
      } catch (err) {
        console.error("Error fetching Haftarah portion:", err);
        setError("An error occurred while loading the Haftarah portion.");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) return <p className="mediumtext" style={{ paddingTop: "60px" }}>Loading Haftarah Portion...</p>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      <br /><br /><br />
      <h2>{isFestival ? "Festival Haftarah Reading" : "Haftarah Portion of the Week"}</h2>
      <h4>Haftarah for {isFestival ? portionName : `Parashat ${portionName}`}{portionHebrew && ` | ${portionHebrew}`}</h4>
      <h5>{haftarahRef}</h5>
      <h6>
        {new Date().toLocaleDateString("en-us", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </h6>
      <div className="bible-chapters-buttons">
        <div className="bible-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(haftarahText) }} />
        <div style={{ paddingTop: 40, width: "100%", display: "block" }} />
      </div>

      {loggedIn ? (
        <>
          <PortionCommentary collectionName="haftarahCommentaries" portionName={portionName} />
          <PortionOthersCommentary collectionName="haftarahCommentaries" portionName={portionName} />
        </>
      ) : (
        <Link to="/login">
          <div style={{ margin: "0 20px" }}>
            <button className="login-button">
              Login to Post Commentary or See Others' Commentary
            </button>
          </div>
        </Link>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({ loggedIn: state.loggedIn });

export default connect(mapStateToProps, {})(HaftarahPortion);
